module.exports = __webpack_public_path__ + "img/84.ac2d3ff7.svg";